import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext } from 'react-admin';
import { LinkButton } from 'shared/mui/Buttons';
import { Mapping } from 'types/embedded/gatewayRule';
import { cleanEmpty } from 'utils/cleanEmpty';

type Props = {
  merchantId: string;
};

export const GatewayRuleMappingOrdersLink: React.FC<Props> = ({ merchantId }) => {
  const translate = useTypedTranslate();
  const { hasResourceAccess } = usePermissions();

  const mappingRecord = useRecordContext<Mapping>();

  if (!hasResourceAccess(Resources.Orders)) {
    return null;
  }

  return (
    <LinkButton
      label={translate('app.gatewayRules.goToOrders')}
      pathParams={{ resource: Resources.Orders, type: 'list' }}
      queryParams={{
        filter: cleanEmpty({
          merchant: merchantId,
          method: [mappingRecord?.method?.['@id']],
          direction: mappingRecord?.direction?.value,
          gateway: mappingRecord?.mappingItems?.map((mappingItem) => mappingItem.gateway?.['@id']),
        }),
      }}
      target="_blank"
    />
  );
};
